import { Component, Input } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'hint-component',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss'],
})
export class HintComponent {
  @Input() tooltipKey: string;
  @Input() tooltipEditable: boolean;

  constructor(public sharedService: SharedService) {
    this.tooltipEditable = false;
  }
}
